


















import Vue from 'vue';
import Piece from '@/components/Piece.vue';
import { colours } from '@/game/model';

export default Vue.component('Tray', {
  props: ['game', 'playPiece'],
  components: {
    Piece
  },
  data() {
    return {
      colours
    };
  }
});
